import type { FC, SVGProps } from 'react';

import { ReactComponent as CalendarFilledIcon } from '../../assets/sideNavigation/calendar_filled.svg';
import { ReactComponent as CalendarOutlinedIcon } from '../../assets/sideNavigation/calendar_outlined.svg';
import { ReactComponent as RoutineFilledIcon } from '../../assets/sideNavigation/routine_filled.svg';
import { ReactComponent as RoutineOutlinedIcon } from '../../assets/sideNavigation/routine_outlined.svg';
import { ReactComponent as TaskFilledIcon } from '../../assets/sideNavigation/task_filled.svg';
import { ReactComponent as TaskOutlinedIcon } from '../../assets/sideNavigation/task_outlined.svg';
import { ReactComponent as DataOutlinedIcon } from '../../assets/sideNavigation/data_outlined.svg';
import { ReactComponent as SettingsOutlinedIcon } from '../../assets/sideNavigation/settings_outlined.svg';
import { ReactComponent as SettingsFilledIcon } from '../../assets/sideNavigation/settings_filled.svg';
import { ReactComponent as DataFilledIcon } from '../../assets/sideNavigation/data_filled.svg';
import { ReactComponent as TeamOutlinedIcon } from '../../assets/sideNavigation/team_people_outlined.svg';
import { ReactComponent as TeamFilledIcon } from '../../assets/sideNavigation/team_people_filled.svg';
import { ReactComponent as ReloadIcon } from '../../assets/sideNavigation/reload.svg';
import { ReactComponent as DownloadIcon } from '../../assets/sideNavigation/download.svg';
import { Path } from '../../routing';

type SideNavigationIcon = FC<SVGProps<SVGSVGElement>>;

export type SideNavigationTab = {
  iconFilled: SideNavigationIcon;
  iconOutlined: SideNavigationIcon;
  path: string;
  title: string;
};

export const SIDE_NAVIGATION_TABS: SideNavigationTab[] = [
  {
    iconFilled: CalendarFilledIcon,
    iconOutlined: CalendarOutlinedIcon,
    path: `${Path.HOME}/calendar`,
    title: 'Calendar',
  },
  {
    iconFilled: TaskFilledIcon,
    iconOutlined: TaskOutlinedIcon,
    path: Path.TASK,
    title: 'Task',
  },
  {
    iconFilled: RoutineFilledIcon,
    iconOutlined: RoutineOutlinedIcon,
    path: Path.ROUTINE,
    title: 'Routine',
  },
  {
    iconFilled: DataFilledIcon,
    iconOutlined: DataOutlinedIcon,
    path: Path.DATA,
    title: 'Data',
  },
  {
    iconFilled: SettingsFilledIcon,
    iconOutlined: SettingsOutlinedIcon,
    path: `${Path.HOME}/settings`,
    title: 'Settings',
  },
  {
    iconFilled: TeamFilledIcon,
    iconOutlined: TeamOutlinedIcon,
    path: Path.TEAM,
    title: 'Team',
  },
];

export { ReloadIcon, DownloadIcon };
